export const routePaths = {
  overview: '/',
  myMachine: '/my-machines',
  machineDetails: '/my-machines/:id',
  claimingProcess: '/claiming-process',
  cleaningReport: '/cleaning-report',
  notifications: '/notifications',
  operators: '/operators',
  privacyPolicy: '/privacy-policy',
  callback: '/callback',
  accountDeleted: '/account-deleted',
  login: '/login',
  dataProtection: '/data-protection',
  emRedirectPage: '/em-redirect'
};
